var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"note--label"},[_vm._v("Latest Note")]),_vm._v(" "),(_vm.recentNote)?_c('p',{staticClass:"note--body",domProps:{"innerHTML":_vm._s(_vm.recentNote.body)}}):_c('p',{staticClass:"note--body is-empty"},[_vm._v("No recent notes")]),_vm._v(" "),_c('notes-default',{staticClass:"mt-100",attrs:{"noteable":_vm.record}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }